import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Moment } from "moment";
import { AppService } from "src/app/core/services/app.service";
import { ReportService } from "src/app/core/services/report.service";
import { CommandCenterReport } from "src/app/shared/models/CommandCenterReportConfiguration.item";
import { SalesSummary } from "src/app/shared/models/focusDataModels/SalesSummary";

@Component({
	selector: "app-daily-sales-report",
	templateUrl: "./daily-sales-report.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class DailySalesReportComponent implements OnInit {
	@Input() report: CommandCenterReport;
	@Output() reportChange = new EventEmitter<CommandCenterReport>();

	endDate: Moment;

	loading: boolean = true;
	startDate: Moment;

	salesSummary: SalesSummary = new SalesSummary();

	constructor(public app: AppService, public reportService: ReportService) {}

	ngOnInit(): void {}

	run() {
		this.app.loading(true);
		if (this.endDate) {
			for (let i = this.startDate; i.isSame(this.endDate); i.add(1, "day")) {
				this.reportService.salesSummaryGet(i.format("MMDDYYYY"));
			}
		} else {
			this.reportService.salesSummaryGet(this.startDate.format("MMDDYYYY"));
		}

		this.reportService.salesSummary.subscribe((data) => {
			if (data.length > 0) {
				this.app.loading(false);
				this.loading = false;
				this.buildReport(data);
			}
		});
	}

	buildReport(data: SalesSummary[]) {
		if (this.endDate) {
			data.forEach((checkDate) => {
				this.salesSummary.AdvanceAmount += checkDate.AdvanceAmount;
				this.salesSummary.CheckCount += checkDate.CheckCount;
				this.salesSummary.NetCash += checkDate.NetCash;
				this.salesSummary.NetSales += checkDate.NetSales;
				this.salesSummary.LaborCost += checkDate.LaborCost;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.VoidCount += checkDate.VoidCount;
				this.salesSummary.DiscountCount += checkDate.DiscountCount;
				this.salesSummary.DiscountAmount += checkDate.DiscountAmount;
				this.salesSummary.RefundCount += checkDate.RefundCount;
				this.salesSummary.RefundAmount += checkDate.RefundAmount;
				this.salesSummary.ReturnItemCount += checkDate.ReturnItemCount;
				this.salesSummary.ReturnItemAmount += checkDate.ReturnItemAmount;
				this.salesSummary.DepositCount += checkDate.DepositCount;
				this.salesSummary.DepositAmount += checkDate.DepositAmount;
				this.salesSummary.GiftCardCount += checkDate.GiftCardCount;
				this.salesSummary.GiftCardAmount += checkDate.GiftCardAmount;
				this.salesSummary.PaidoutCount += checkDate.PaidoutCount;
				this.salesSummary.PaidoutAmount += checkDate.PaidoutAmount;
				this.salesSummary.TipFee += checkDate.TipFee;
				this.salesSummary.NetCash += checkDate.NetCash;
				this.salesSummary.GuestCount += checkDate.GuestCount;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.VoidAmount += checkDate.VoidAmount;
				this.salesSummary.turnTimeInSeconds += this.compileAverageTime(checkDate.AverageTime);

				//calculate averages and percentages last
			});
			this.salesSummary.AverageCheck = this.salesSummary.NetSales / this.salesSummary.CheckCount;
			this.salesSummary.LaborPercentage = this.salesSummary.LaborCost / this.salesSummary.NetSales;
			this.salesSummary.AverageGuest = this.salesSummary.NetSales / this.salesSummary.GuestCount;
			this.salesSummary.AverageTime = this.fancyTimeFormat(this.salesSummary.turnTimeInSeconds / this.endDate.diff(this.startDate, "days"));
		} else {
			this.salesSummary = data.find((i) => i.CheckDate === this.startDate.format("MMDDYYYY"));
		}
	}

	compileAverageTime(averageTime: string): number {
		let seconds = 0;
		const timeParts = averageTime.split(":");
		if (+timeParts[0]) {
			seconds += +timeParts[0] * 3600;
		}
		if (+timeParts[1]) {
			seconds += +timeParts[1] * 60;
		}
		if (+timeParts[2]) {
			seconds += +timeParts[2];
		}
		return seconds;
	}

	fancyTimeFormat(duration) {
		// Hours, minutes and seconds
		var hrs = ~~(duration / 3600);
		var mins = ~~((duration % 3600) / 60);
		var secs = ~~duration % 60;

		// Output like "1:01" or "4:03:59" or "123:03:59"
		var ret = "";

		if (hrs > 0) {
			ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
		}

		ret += "" + mins + ":" + (secs < 10 ? "0" : "");
		ret += "" + secs;
		return ret;
	}
}
